import { useChangelogAvailable } from "hooks/useChangelogAvailable";

import type { Command } from "../../types";

type CommandParams = {
  source?:
    | "ui"
    | "panel_placeholder"
    | "main_menu"
    | "command_palette"
    | "keyboard";
  panelId?: string;
};

export const useOpenChangelog = (_props: CommandParams): Command => {
  const changelog = useChangelogAvailable();

  return {
    id: "codesandbox.changelog.open",
    section: "CodeSandbox",
    name: "Open Changelog",
    perform: () => {
      changelog.open();
    },
  };
};
